export default __webpack_public_path__ + "static/media/digital-airfield.dbc52da0.jpg";